import api from "./baseApi.js"

export default {

    Download(guid) {
        return api.get("Files/Download/" + guid, { responseType: 'arraybuffer' });
    },

    DownloadZip(guids) {
        return api.post("Files/Download", guids, { responseType: 'arraybuffer' });
    },

    Get(guid) {
        return api.get("Files/Get/" + guid);
    },

    UploadFull(fullFileUpload) {
        return api.post("Files/UploadFull", fullFileUpload);
    },

    DeleteFull(guid, username) {
        return api.delete("Files/DeleteFull/" + guid + "/" + username);
    },
}
